// Routes currently used in the AI-redesigned site.  The site is a single-
// page Home with two ancillary legal pages — all other URLs were removed
// during the redesign.
const APP_URLS = {
    HOME:   "/",
    TERMS:  "/terms",
    POLICY: "/policy",
};

const URLS = {
    BLOG_API: process.env.REACT_APP_BLOG_API,
};

export { URLS, APP_URLS };
